/* OTHERSPORTS · Such-Hilfe (23.10.2026)
   Ergänzt das Suchfeld der Kopfzeile (#os-suche – Öffnen/Schließen macht os-neu-main.js) um ein helles Panel:
   leeres Feld → beliebte Suchen und Direktwege (snippets/os-suche-wege.liquid),
   ab 2 Zeichen → Live-Vorschläge aus sections/os-suche-vorschlaege.liquid über Shopifys Predictive Search
   (Section Rendering API). Enter schickt wie bisher an die Shop-Suche (/search). */
(function () {
  'use strict';
  var doc = document;
  var box = doc.getElementById('os-suche');
  var vorlage = doc.getElementById('os-sh-vorlage');
  if (!box || !vorlage || !('content' in vorlage)) return;
  var form = box.querySelector('form');
  var feld = box.querySelector('input[name="q"]');
  if (!form || !feld || box.querySelector('[data-os-sh]')) return;

  box.appendChild(doc.importNode(vorlage.content, true));
  var panel = box.querySelector('[data-os-sh]');
  var start = panel.querySelector('[data-os-sh-start]');
  var ergebnis = panel.querySelector('[data-os-sh-ergebnis]');
  var basis = panel.getAttribute('data-url') || '/search/suggest';
  box.classList.add('os-sh-aktiv');
  feld.setAttribute('autocomplete', 'off');
  feld.setAttribute('aria-controls', 'os-sh-ergebnis');

  var cache = {};
  var timer = 0;
  var ctrl = null;

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function suchUrl(q) {
    return (form.getAttribute('action') || '/search') + '?q=' + encodeURIComponent(q) + '&type=product,page,article&options%5Bprefix%5D=last';
  }
  function zeigeStart() {
    start.hidden = false;
    ergebnis.hidden = true;
  }
  function zeigeErgebnis(html) {
    ergebnis.innerHTML = html;
    ergebnis.hidden = false;
    start.hidden = true;
  }
  function holen(q) {
    var key = q.toLowerCase();
    if (Object.prototype.hasOwnProperty.call(cache, key)) { zeigeErgebnis(cache[key]); return; }
    if (ctrl) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    panel.classList.add('is-laedt');
    var url = basis + '?q=' + encodeURIComponent(q) + '&section_id=os-suche-vorschlaege' +
      '&resources%5Btype%5D=product%2Cpage%2Carticle%2Ccollection%2Cquery' +
      '&resources%5Blimit%5D=6&resources%5Blimit_scope%5D=each' +
      '&resources%5Boptions%5D%5Bunavailable_products%5D=last';
    var opt = { credentials: 'same-origin' };
    if (ctrl) opt.signal = ctrl.signal;
    fetch(url, opt)
      .then(function (r) { if (!r.ok) throw new Error('Status ' + r.status); return r.text(); })
      .then(function (text) {
        var d = new DOMParser().parseFromString(text, 'text/html');
        var s = d.querySelector('.os-sv');
        if (!s) throw new Error('leer');
        cache[key] = s.outerHTML;
        if (feld.value.trim().toLowerCase() === key) zeigeErgebnis(cache[key]);
        panel.classList.remove('is-laedt');
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        panel.classList.remove('is-laedt');
        if (feld.value.trim().toLowerCase() !== key) return;
        zeigeErgebnis('<div class="os-sv"><a class="os-sv__alle" href="' + esc(suchUrl(q)) + '"><span>Alle Ergebnisse für „' + esc(q) + '“</span></a></div>');
      });
  }
  function aktualisieren(sofort) {
    var q = feld.value.trim();
    clearTimeout(timer);
    if (q.length < 2) {
      if (ctrl) ctrl.abort();
      panel.classList.remove('is-laedt');
      zeigeStart();
      return;
    }
    if (sofort) holen(q);
    else timer = setTimeout(function () { holen(q); }, 220);
  }

  feld.addEventListener('input', function () { aktualisieren(false); });

  /* Chips füllen das Feld, Finder-Wege schließen erst die Suche (der Finder öffnet sich danach selbst) */
  panel.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-os-sh-q]');
    if (chip) {
      e.preventDefault();
      feld.value = chip.getAttribute('data-os-sh-q');
      aktualisieren(true);
      panel.scrollTop = 0;
      return;
    }
    if (e.target.closest('[data-finder-open]')) {
      var zu = box.querySelector('[data-os-suche-close]');
      if (zu) zu.click();
    }
  });

  /* Beim Öffnen sofort ins Feld (im selben Tipp – sonst öffnet iOS die Tastatur nicht) und passenden Zustand zeigen */
  doc.addEventListener('click', function (e) {
    if (!e.target.closest('[data-os-suche-open]') || box.hidden) return;
    try { feld.focus({ preventScroll: true }); } catch (err) { feld.focus(); }
    aktualisieren(true);
  });

  /* Pfeiltasten: vom Feld in die Liste und zwischen den Einträgen */
  function eintraege() {
    var bereich = ergebnis.hidden ? start : ergebnis;
    return Array.prototype.slice.call(bereich.querySelectorAll('a[href]')).filter(function (a) { return a.offsetParent !== null; });
  }
  box.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var liste = eintraege();
    if (!liste.length) return;
    var i = liste.indexOf(doc.activeElement);
    if (doc.activeElement === feld) {
      if (e.key !== 'ArrowDown') return;
      e.preventDefault();
      liste[0].focus();
      return;
    }
    if (i < 0) return;
    e.preventDefault();
    if (e.key === 'ArrowDown') { if (liste[i + 1]) liste[i + 1].focus(); }
    else if (i === 0) feld.focus();
    else liste[i - 1].focus();
  });
})();
